import { motion } from "framer-motion";
import { EASE } from "./Reveal";
import { Sparkle } from "./Sparkle";

export const PageHero = ({ eyebrow, titleLines, quote, image, testId, imageAlt = "" }) => (
  <section
    data-testid={testId}
    className="relative min-h-[70vh] flex items-end overflow-hidden bg-espresso"
  >
    <motion.div
      className="absolute inset-0"
      initial={{ scale: 1.12 }}
      animate={{ scale: 1 }}
      transition={{ duration: 2.2, ease: EASE }}
    >
      <img
        src={image}
        alt={imageAlt}
        className="w-full h-full object-cover opacity-60"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-espresso via-espresso/40 to-espresso/30" />
    </motion.div>

    <div className="relative max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 pb-16 sm:pb-24 pt-40 w-full">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.7, ease: EASE }}
        className="font-sans uppercase tracking-[0.22em] text-xs font-medium text-champagne flex items-center gap-3"
      >
        <Sparkle size={11} />
        {eyebrow}
      </motion.p>
      <h1 className="font-display text-5xl sm:text-7xl lg:text-8xl text-ivory mt-6 leading-[1.02]">
        {titleLines.map((line, i) => (
          <span key={i} className="block overflow-hidden pb-1">
            <motion.span
              className="block"
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ delay: 0.35 + i * 0.14, duration: 0.9, ease: EASE }}
            >
              {line}
            </motion.span>
          </span>
        ))}
      </h1>
      {quote && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.9, duration: 0.8, ease: EASE }}
          className="font-quote italic text-xl sm:text-2xl text-ivory/75 mt-6 max-w-xl"
        >
          {quote}
        </motion.p>
      )}
    </div>
  </section>
);
